import { useRef } from 'react'

import { Box, Field, Input, InputGroup, Slider, Text } from '@chakra-ui/react'
import { INFO_PANEL_PADDING } from '@editor/config/styles'
import { IntervalsAxisConfig } from '@editor/interfaces/inspectionItemGrid'

import { validateAxisConfigValue } from '../../utils'

const CenterBasedAxisConfig = ({
  side,
  axisConfig,
  selectedVolumeId,
  patchAxisConfig,
}: {
  side: string
  axisConfig: IntervalsAxisConfig
  selectedVolumeId: string
  patchAxisConfig: (axisConfig: Partial<IntervalsAxisConfig>) => void
}) => {
  // Refs
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <Field.Root px={INFO_PANEL_PADDING} py={INFO_PANEL_PADDING} invalid={!validateAxisConfigValue(axisConfig.interval)}>
      <Text>{side}</Text>
      <InputGroup endElement="mm">
        <Input
          ref={inputRef}
          type="number"
          defaultValue={axisConfig.interval.value}
          size="sm"
          min={axisConfig.interval.min}
          max={axisConfig.interval.max}
          background="gray2.700"
          borderColor="whiteAlpha.200"
          borderRadius={5}
          disabled={!selectedVolumeId}
          onChange={(e) => {
            const value = parseInt(e.target.value, 10)
            patchAxisConfig({
              interval: { ...axisConfig.interval, value },
            })
          }}
        />
      </InputGroup>
      <Box mb={2} px={2} w="full">
        <Slider.Root
          colorPalette="blue"
          defaultValue={[axisConfig.interval.value]}
          min={axisConfig.interval.min}
          max={axisConfig.interval.max}
          step={1}
          disabled={!selectedVolumeId}
          onValueChange={(e) => {
            patchAxisConfig({ interval: { ...axisConfig.interval, value: e.value[0] } })

            if (inputRef.current) {
              inputRef.current.value = e.value[0].toString()
            }
          }}
        >
          <Slider.Control>
            <Slider.Track>
              <Slider.Range />
            </Slider.Track>
            <Slider.Thumb index={0} />
          </Slider.Control>
        </Slider.Root>
      </Box>
      <Field.ErrorText fontSize="xs">
        {axisConfig.interval.min}~{axisConfig.interval.max}の間の値を設定してください
      </Field.ErrorText>
    </Field.Root>
  )
}

export default CenterBasedAxisConfig
